import { Navigate } from "react-router-dom";
import { useScope } from "../context/ScopeContext";
import {
  OVERVIEW_PATHS,
  effectiveOverviewProduct,
  overviewProductsFor,
} from "../nav/customerOverview";

/**
 * `/overview` - where a customer lands. Resolves to the Frontlayer or Signage
 * overview by the header's product selector (see nav/customerOverview.ts).
 * It waits for the location directory, because which of the two a customer
 * HAS is a fact about their places; with neither, the location list.
 */
export default function OverviewRedirect() {
  const { scope, premises, loaded } = useScope();
  if (!loaded) return null;
  const product = effectiveOverviewProduct(
    scope.product,
    overviewProductsFor(premises)
  );
  return (
    <Navigate to={product ? OVERVIEW_PATHS[product] : "/premises"} replace />
  );
}
